import React, { useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import Head from 'next/head';
import fetchBanks from '../../../../api/dbs/fetchBanks';
import { DepositTakingBankListItem, sortingOptions } from '../../../../types';
import { calculateMinHeight } from '../../../../utils/bankPageUtils';
import { BankFilterBar, BankListItem, Loader } from './components';
import * as S from './styles';

const BankList = ({ banks }) => {
  const [sortBy, setSortBy] = useState(sortingOptions.BANK_NAME);
  const [isLoading, setIsLoading] = useState(false);
  const [sortedBanks, setSortedBanks] = useState<DepositTakingBankListItem[]>(banks);
  const [minHeight, setMinHeight] = useState(0);
  const total = useMemo(() => banks.filter((bank) => Boolean(bank.bank_slug)).length, [banks]);

  const { locale } = useIntl();

  const querySelector = 'bankListItemLink';

  const fetchData = async (sortByValue) => {
    setIsLoading(true);
    try {
      const response = await fetchBanks({ locale: locale }, sortByValue);
      setSortedBanks(response?.entries);
      setIsLoading(false);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching data:', error);
    }
  };

  const handleClick = (value) => {
    setSortBy(value);
    setMinHeight(calculateMinHeight(querySelector, total));
    fetchData(value);
  };

  return (
    <>
      <Head>
        <meta name="robots" content="index, follow" />
      </Head>
      <S.Container>
        <BankFilterBar sortBy={sortBy} onChange={(value) => handleClick(value)} total={total} />
      </S.Container>
      <S.BankListContainer sx={{ minHeight: minHeight }} data-testid="banks-list">
        {isLoading ? (
          <Loader />
        ) : (
          <>
            {sortedBanks.map(
              (bank) =>
                Boolean(bank.bank_slug) && (
                  <BankListItem querySelector={querySelector} bank={bank} key={bank.id} />
                ),
            )}
          </>
        )}
      </S.BankListContainer>
    </>
  );
};

export default BankList;
